import { stateListParamName, prepareOfficesList } from './model';
import {
  stateParamName as readyStateParamName,
  getReadyStateModel
} from '../readyState';
import {
  LOAD_OFFICES,
  LOAD_OFFICES_SUCCESS,
  LOAD_OFFICES_FAIL
} from './constants';
import get from 'lodash/get';

const initialState = {
  [stateListParamName]: [],
  [readyStateParamName]: getReadyStateModel()
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_OFFICES:
      return {
        ...state,
        [readyStateParamName]: getReadyStateModel({ loading: true })
      };
    case LOAD_OFFICES_SUCCESS:
      const { data } = get(action, 'result', {});
      if (Array.isArray(data)) {
        return {
          ...state,
          [stateListParamName]: prepareOfficesList(data),
          [readyStateParamName]: getReadyStateModel({ complete: true })
        };
      }
      return {
        ...state,
        [readyStateParamName]: getReadyStateModel({ error: true })
      };
    case LOAD_OFFICES_FAIL:
      return {
        ...state,
        [readyStateParamName]: getReadyStateModel({ error: true })
      };
    default:
      return state;
  }
};
